export * from './auth/auth.guard';
export * from './services';
export * from './ngbdateparsers';
export * from './ngbmomentpickers';



// WEBPACK FOOTER //
// ./src/app/shared/index.ts